<template>
    <div class="form__field form__field--image has-dynamic-error"
         :class="{'is-loading' : isLoading, 'is-active' :isActive, 'is-interacted' : isInteracted, 'has-error' : errormMessage }">

        <span class="account-image__alert" v-show="isReady" v-text="label"></span>

        <input type="file"
               @change="handleChange"
               id="file_input"
               ref="file_input"
               name="file_input"
               accept="image/jpg, image/jpeg, image/png, image/heic" class="form_input required accessible">

        <label for="file_input">
            <img :src="previewImg" class="form__field--image__img" alt="label" />
            <div class="edit" role="button" tabindex="0"><svg class="folder"><use xlink:href="#folder"></use></svg></div>
        </label>

        <div class="crop-wrapper" ref="crop_wrapper">
            <div class="reference"></div>
            <div id="js-accept-crop" @click="onAccept()" v-show="isReady" class="yes" role="button" tabindex="0">
                <svg class="accept"><use xlink:href="#accept"></use></svg>
            </div>
            <div id="js-cancel-crop" @click="onCancel()" v-show="isReady" class="no" role="button" tabindex="0">
                <svg class="deny"><use xlink:href="#deny"></use></svg>
            </div>
            <div class="smaller" role="button" tabindex="0">
                <svg class="minus"><use xlink:href="#minus"></use></svg>
            </div>
            <div class="bigger" role="button" tabindex="0">
                <svg class="plus-2"><use xlink:href="#plus-2"></use></svg>
            </div>
        </div>

        <span class="error" v-if="errormMessage" v-text="errormMessage"></span>
        <div v-if="(isActive && !isReady)" class="loading-text">Loading Photo</div>

    </div>
</template>
<script>

const EXIF = require('exif-js')
const heic2any = require('heic2any')
const Croppie = require('croppie')

export default {

    props: {
        value: {},
        label: {},
        errors : {},
        defaultImg: {
            type: String,
            required: false,
            default: '/img/person.png'
        }
    },

    data() {
        return {
            isReady: false,
            file: this.value,
            previewImg: this.defaultImg,
            isInteracted: false,
            isLoading: false,
            isActive: false,
            cropper: null,
            cropWrap: null,
            input: null,
            errormMessage: this.errors,
        }
    },

    mounted() {
        this.input = this.$refs.file_input
        this.cropWrap = this.$refs.crop_wrapper
        this.createCropper()
    },

    methods: {

        submit(dataURI) {
            fetch(dataURI)
                .then(response => response.blob())
                .then(blob => {
                    const file = new File([blob], "profile-photo.jpg", {type: blob.type})
                    this.$emit('input', file)
                    this.$emit('change', file)
                    this.input.disabled = false
                })
        },

        createCropper() {
            this.cropper = new Croppie(this.cropWrap, {
                enableExif: true,
                enableOrientation: true,
                viewport: {width: 106, height: 106, style: 'circle'},
                boundary: {width: 106, height: 106},
            })
        },

        onAccept() {
            this.cropper
                .result({
                    type: 'canvas',
                    size: {},
                })
                .then(image => {
                    this.previewImg = image
                    this.closeCropper(true)
                    return image
                })
                .then(res => {
                    this.submit(res)
                })
                .catch(() => {
                    this.input.disabled = false
                })
        },

        onCancel() {
            this.input.disabled = false
            this.closeCropper()
        },

        closeCropper(loading = false) {
            if (this.cropper) {
                this.cropper.destroy()
                this.cropper = null
            }

            this.isLoading = loading
            this.input.value = null
            this.isActive = false
        },

        handleChange() {

            this.errormMessage = "";

            let filesize = this.getFileSize(event.target.files[0])
            if(filesize > 10) {
                this.$emit('error')
                this.errormMessage = "The profile picture may not be greater than 10MB."
                return;
            }

            this.isReady = false
            this.input.disabled = true

            const reader = new FileReader()

            if (this.cropper) {
                this.cropper.destroy()
                this.cropper = null
            }

            this.createCropper()

            // define what to do when the image loads in the FileReader
            reader.onload = event => {
                this.isActive = true
                this.isInteracted = true
                this.formatImageFileType(event.target.result)
                    .then(file => {
                        this.cropper.bind({url: file})
                            .then(() => {
                                this.isReady = true
                            })
                    })
            }

            reader.readAsDataURL(this.input.files[0])
        },

        formatImageFileType(file) {
            const fileType = this.getFileTypeFromBase64(file)
            if (fileType !== 'heic') return new Promise(resolve => resolve(file))
            const blob = this.dataURItoBlob(file)
            return this.convertHeicToJpeg(blob).then(blob => this.convertToBase64(blob))
        },

        convertToBase64(blob) {
            return new Promise(resolve => {
                const reader = new FileReader()
                reader.onloadend = evt => {
                    resolve(evt.target.result)
                }
                reader.readAsDataURL(blob)
            })
        },

        convertHeicToJpeg(file) {
            return new Promise(resolve => {
                resolve(
                    heic2any({
                        blob: file,
                        toType: 'image/jpeg',
                        quality: 0.8,
                    })
                )
            })
        },

        getFileTypeFromBase64(string) {
            return string.match(/[^:/]\w+(?=;|,)/)[0]
        },

        dataURItoBlob(dataURI) {
            var byteString = atob(dataURI.split(',')[1]);
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            // write the bytes of the string to an ArrayBuffer
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ab], {type: mimeString});
        },

        getFileSize(file) {
            if (window.ActiveXObject) {
                var fso = new ActiveXObject("Scripting.FileSystemObject");
                var filepath = file.value;
                var thefile = fso.getFile(filepath);
                return thefile.size / 1000000;
            }
            return file.size / 1000000;
        }
    },

    watch: {
        value() {
            this.file = this.value
        },
        errors(){
            this.errormMessage = this.errors
        }
    }
}
</script>
<style>
.loading-text {
    background: black;
    padding: 3px 5px;
    border-radius: 6px;
    text-align: center;
    color: #E8E0CC;
    font-size: 10px;
    position: absolute;
    bottom: 10px;
}
</style>
